import React from 'react';
import styled from 'styled-components';



export const Row_60 = styled.div`
    width : 60%;
    display : flex;
    justify-content : space-between;
`


export const Container = styled.div`
    width : 100%;
    display : flex;
    input {
        background: white;
        
     }
`
